import { esecuzioneVerde, formattaDurata } from './Functions'
import { t } from './testi'

/** Il pallino verde/rosso di un'esecuzione, con il testo per chi non vede i colori. */
const Punto = ({ verde }) => (
  <>
    <span className={`ae-punto ${verde ? 'is-ok' : 'is-ko'}`} aria-hidden="true" />
    <span className="ae-sr">{verde ? t.aeVerde : t.aeRosso}</span>
  </>
)

const comeTesto = (valore) =>
  typeof valore === 'string' ? valore : JSON.stringify(valore, null, 2)

/** Un tool chiamato in un turno: nome, motivo del rifiuto, argomenti ed esito. */
const Strumento = ({ strumento }) => (
  <div className="ae-strumento">
    <strong>{strumento.nome}</strong>
    {strumento.motivo ? <span className="ae-caduto-inline"> {strumento.motivo}</span> : null}
    {strumento.args !== undefined ? (
      <pre className="ae-json">{comeTesto(strumento.args)}</pre>
    ) : null}
    {strumento.esito ? <code className="ae-turno__audit">{String(strumento.esito)}</code> : null}
  </div>
)

/** Un turno della conversazione: la battuta del viaggiatore, la risposta di Nora, i tool. */
const Turno = ({ turno }) => (
  <div className="ae-turno">
    <div className="ae-turno__utente">{turno.utente}</div>
    <div className="ae-turno__nora">{turno.testo || '—'}</div>
    <code className="ae-turno__audit">
      {turno.stopReason} · {turno.audit || t.aeNessunTool}
    </code>
    {turno.strumenti?.length ? (
      <details className="ae-strumenti">
        <summary className="ae-muto">
          {t.aeStrumenti} ({turno.strumenti.length})
        </summary>
        {turno.strumenti.map((strumento, j) => (
          <Strumento key={j} strumento={strumento} />
        ))}
      </details>
    ) : null}
  </div>
)

/**
 * Una esecuzione di conversazione: i controlli caduti in alto, poi i turni con testo e tool.
 * Le rosse si aprono da sole: sono quelle da leggere.
 */
export const EsecuzioneConversazione = ({ esecuzione, indice }) => {
  const caduti = (esecuzione.verdetti ?? []).filter((v) => !v.passato)
  const verde = esecuzioneVerde(esecuzione, 'conversazione')
  return (
    <details className="ae-esecuzione" open={!verde}>
      <summary>
        <Punto verde={verde} />
        <strong>
          {t.aeEsecuzione} #{(esecuzione.indice ?? indice) + 1}
        </strong>
        <span className="ae-muto">
          {' · '}
          {formattaDurata(esecuzione.durataMs)}
          {esecuzione.interrottaAlTurno !== undefined ? ` · ${t.aeInterrotta}` : ''}
          {esecuzione.errore ? ` · ${esecuzione.errore}` : ''}
        </span>
      </summary>
      {caduti.length ? (
        <ul className="ae-caduti">
          {caduti.map((v) => (
            <li key={v.nome}>
              <strong>{v.nome}</strong>
              {(v.detail ?? v.dettaglio) ? <span> — {v.detail ?? v.dettaglio}</span> : null}
            </li>
          ))}
        </ul>
      ) : null}
      {esecuzione.turni?.length ? (
        esecuzione.turni.map((turno, i) => <Turno key={i} turno={turno} />)
      ) : (
        <p className="ae-muto ae-nota">{t.aeTrascrizioneAssente}</p>
      )}
      <details className="ae-strumenti">
        <summary className="ae-muto">{t.aeRichiestaFinale}</summary>
        <pre className="ae-json">{JSON.stringify(esecuzione.richiestaFinale, null, 2)}</pre>
      </details>
    </details>
  )
}

/** Una esecuzione di un punto di decisione: la mossa e i suoi argomenti. */
export const EsecuzioneDecisione = ({ esecuzione, indice }) => {
  const verde = esecuzioneVerde(esecuzione, 'decisione')
  return (
    <details className="ae-esecuzione" open={!verde}>
      <summary>
        <Punto verde={verde} />
        <strong>
          {t.aeEsecuzione} #{(esecuzione.indice ?? indice) + 1}
        </strong>
        <span className="ae-muto">
          {' · '}
          {esecuzione.mossa}
          {esecuzione.valida ? '' : ` · ${t.aeNonConta}`}
          {esecuzione.errore ? ` · ${esecuzione.errore}` : ''}
        </span>
      </summary>
      {esecuzione.testo ? <div className="ae-turno__nora">{esecuzione.testo}</div> : null}
      <pre className="ae-json">{JSON.stringify(esecuzione.toolCalls, null, 2)}</pre>
      {esecuzione.esitiTool?.map((esito, i) => (
        <code key={i} className="ae-turno__audit">
          {esito}
        </code>
      ))}
    </details>
  )
}
